/* eslint-disable camelcase */

export default {
  action: {
    back: 'Indietro',
    cancel: 'Annullare',
    close: 'Chiudere',
    collapseDetails: 'Meno dettagli',
    confirm: 'Confermare',
    confirmAndInvite: 'Confermare e invitare',
    continue: 'Continuare',
    createAccount: "Creazione dell'account",
    expandDetails: 'Più dettagli',
    invite: 'Invitare',
    logout: 'Scollegamento',
    no: 'No',
    openSwitchOrganisation: "Selezionare un'azienda:",
    organisation: 'Azienda',
    resendEmail: "Rimandare l'e-mail di attivazione",
    returnToHome: 'Andare alla home page',
    settings: 'Profilo',
    skip: 'Saltare',
    yes: 'Sì'
  },
  activateUser: {
    button: "rimandare l'e-mail di attivazione",
    emailSent: 'Abbiamo inviato una nuova e-mail',
    linkLabel: ' accedere al mio account',
    message: 'Abbiamo inviato una e-mail a %{email}',
    messageLink: 'Ho già cliccato sul tasto, ',
    resendMessage: 'Non ho ricevuto e-mail, ',
    subMessage: 'La preghiamo di cliccare sul link di conferma per attivare il suo account.',
    title: 'La ringraziamo per avere creato un account su OnceForAll'
  },
  address: {
    addressLine: 'Indirizzo',
    city: 'Città',
    country: 'Paese',
    region: 'Regione',
    postCode: 'Codice postale',
    title: 'Indirizzo'
  },
  bdr: {
    access: {
      confirm: 'Go to Bâtisseur de Relations',
      collector: {
        text1: '__sBâtisseur de Relations : A unique business platform to find your future projects__s',
        text2: '__sLooking for a new supplier for a specific project?__s',
        text3: 'Bâtisseur de Relations platform allows you to :',
        text4: '  - Publish projects and search for suppliers according to your criteria and needs.',
        text5: '  - Find pre-qualified suppliers.',
        text6: '  - Ensure compliance for all your operations.',
        text7: '__sSave time in sourcing and focus on your core business with Bâtisseur de Relations !__s',
        text8: 'By clicking on "%{confirm}", your user account and your companies on OnceForAll platform will be automatically synced.'
      },
      depositor: {
        text1: '__sBâtisseur de Relations : A unique business platform to find your future projects.__s',
        text2: '__sDo you want to develop your business?__s',
        text3: 'Bâtisseur de Relations platform allows you to :',
        text4: '  - Search and consult public tenders.',
        text5: '  - Receive projects from private contractors.',
        text6: '  - Be listed on the largest network of construction companies in France.',
        text7: '__sSave time searching for projects and win new contracts with Bâtisseur de Relations !__s',
        text8: 'By clicking on "%{confirm}", your user account and your companies on OnceForAll platform will be automatically synced.'
      }
    },
    discover: {
      collector: {
        dashboard: {
          text: "Find qualified suppliers for your future projects from France's largest construction network."
        },
        other: {
          text: "Find qualified suppliers for your future projects from France's largest construction network."
        }
      },
      confirm: 'Try now',
      depositor: {
        text: 'Find new public and private business opportunities on a single platform and grow your business!'
      },
      title: '__sBâtisseur de Relations :__s'
    },
    errorNoUserAndBdrService: {
      text1: 'Si è verificato un errore durante la creazione del tuo profilo Marketplace. Ci scusiamo per il disagio.',
      text2: 'Ti preghiamo di informarci al seguente indirizzo : <a href="mailto:service.clients@onceforall.fr" title="mailto:service.clients@onceforall.fr">service.clients@onceforall.fr</a>.',
      text3: 'A presto sulla nostra piattaforma, il team di Once For All'
    },
    errorNoBdrService: {
      text1: 'La tua offerta attuale non ti consente di accedere a questo servizio. Ci scusiamo per il disagio.',
      text2: '👉 <a href="/alg/organisation/subscription">Vedi la mia offerta</a>',
      text3: 'A presto sulla nostra piattaforma!'
    }
  },
  banette: {
    documentName: 'Nome del documento',
    explanatoryTooltip: "I documenti caricati in questo \"Cestino\" saranno visibili a tutte le aziende dell'operazione",
    noDocument: 'Nessun documento è presente attualmente nel suo elenco.',
    pleaseAddDocument: 'La preghiamo di cliccare su "+" per aggiungere un documento al suo cestino operazione.',
    requireCCRD: 'Chiedere Certificato Decennale Nominativo',
    requireCRSE: 'Chiedere Carta RSI',
    uploadNewDocument: 'Depositare un documento',
    widgetTitle: 'Cestino'
  },
  client: {
    accessCode: {
      additionalInformation: 'Informazioni complementari',
      clientOrgName: "Ragione sociale dell'azienda invitata",
      generateButton: 'Generare un codice di accesso',
      generateText: 'Generare un codice di accesso',
      generateWarning: 'Solo i clienti francesi possono essere invitati.',
      responseToAccessCode: 'Risposta a una gara di appalto',
      tenderReference: 'Riferimento della gara di appalto'
    },
    add: {
      button: 'Aggiungere un cliente',
      inviteSuccess: "L'azienda %{name} è stato aggiunto al suo elenco di clienti!",
      notice: 'Lei condivide i suoi documenti con i clienti che invita.',
      title: 'Aggiungere un cliente'
    },
    documents: 'I miei documenti per %{clientName}',
    invitations: {
      actions: {
        accept: 'Accettare',
        decline: 'Rifiutare',
        resend: 'Invitare di nuovo',
        tooltip: 'Deve attendere %{count} giorni per rimandare questo invito'
      },
      noSent: 'Nessun invito da visualizzare',
      received: 'Inviti ricevuti',
      sent: 'Inviti inviati'
    },
    invite: {
      defaultMessage: '%{userName} di %{organisationName} la invita a consultare la sua documentazione sulla piattaforma OnceForAll al fine di facilitare la gestione documentale.\nDa più di dieci anni OnceForAll gestisce, controlla e condivide documenti amministrativi per le più importanti aziende europee nel settore della costruzione.\nOnceForAll gestisce, controlla e condivide documenti amministrativi per il settore della costruzione.\nPermette di gestire con un’unica piattaforma l’integralità della documentazione dei subappaltatori, completa ed aggiornata.\nNon appena sarà iscritto, potrà accedere gratuitamente e in qualsiasi momento al dossier amministrativo della società %{organisationName} e dei suoi altri fornitori presenti sulla piattaforma.',
      inviteSuccess: "Una volta che l'utente invitato si registra su OnceForAll e aggiunge la sua organizzazione, questa sarà automaticamente collegata alla vostra come uno dei suoi subappaltatori.",
      title: 'Invitare un cliente'
    },
    myClients: 'Clienti',
    relationshipAccepted: "L'invito del suo cliente è stato accettato!",
    relationshipAlreadyReplied: "Ha già risposto all'invito",
    relationshipRejected: "L'invito del suo cliente è stato rifiutato!",
    search: {
      notFound: 'Nessun cliente trovato'
    }
  },
  contact: {
    content: 'Desidera precisare la sua domanda',
    creationSuccess: 'La sua domanda è stata presa in considerazione',
    email: 'kontakt.de@onceforall.com',
    horary: {
      alg_fr: 'Aperto dal lunedì al giovedì dalle 8h30 alle 12h30 e dalle 13h30 alle 18h, e il venerdì dalle 8h30 alle 12h30 e dalle 13h30 alle 17h',
      ofa_de: 'Aperto dal lunedì al venerdì dalle 9h alle 17h',
      ofa_it: 'Aperto dal lunedì al venerdi dalle 9h00 alle 12h30 e dalle 13h30 alle 17h'
    },
    phone: {
      alg_fr: '+33 4 72 38 32 58',
      ofa_de: '+49 30 397 160 82',
      ofa_it: '+39 02 3056 9038'
    },
    subtype: 'E in modo più specifico',
    title: 'Contatti',
    type: 'La sua domanda riguarda',
    types: {
      FileClaim: 'Fare un reclamo',
      IdeaSuggestion: "Proporre un'idea, una testimonianza",
      MyCustomers: 'I miei clienti',
      MyDocuments: 'I miei documenti',
      MyOffer: 'La mia offerta',
      MyProjects: 'Le mie operazioni',
      MyReferencesList: 'Il mio elenco di referenze edilizie',
      MyRole: 'Il mio ruolo',
      MySettings: 'I miei parametri',
      MySuppliers: 'I miei fornitori',
      MyTraining: 'La mia formazione'
    }
  },
  country: {
    ANDORRA: 'Andorra',
    AUSTRIA: 'Austria',
    BELGIUM: 'Belgio',
    BOLIVIA: 'Bolivia',
    BULGARIA: 'Bulgaria',
    CROATIA: 'Croazia',
    CZECH_REPUBLIC: 'Repubblica Ceca',
    DENMARK: 'Danimarca',
    ESTONIA: 'Estonia',
    FRANCE: 'Francia',
    GERMANY: 'Germania',
    GREECE: 'Grecia',
    HUNGARY: 'Ungheria',
    ICELAND: 'Islanda',
    INDIA: 'India',
    ITALY: 'Italia',
    IVORY_COAST: "Costa d'Avorio",
    LATVIA: 'Lettonia',
    LITHUANIA: 'Lituania',
    LUXEMBOURG: 'Lussemburgo',
    MAURITIUS: 'Mauritius',
    MEXICO: 'Messico',
    MONACO: 'Monaco',
    NETHERLANDS: 'Paesi Bassi',
    POLAND: 'Polonia',
    PORTUGAL: 'Portogallo',
    ROMANIA: 'Romania',
    SERBIA: 'Serbia',
    SLOVAKIA: 'Slovacchia',
    SLOVENIA: 'Slovenia',
    SPAIN: 'Spagna',
    SWEDEN: 'Svezia',
    SWITZERLAND: 'Svizzera',
    UNITED_KINGDOM: 'Regno Unito',
    flags: {
      AD: 'Andorra',
      AT: 'Austria',
      BE: 'Belgio',
      BG: 'Bulgaria',
      BO: 'Bolivia',
      CH: 'Svizzera',
      CI: "Costa d'Avorio",
      CZ: 'Repubblica Ceca',
      DE: 'Germania',
      DK: 'Danimarca',
      EE: 'Estonia',
      ES: 'Spagna',
      FR: 'Francia',
      GB: 'Regno Unito',
      GR: 'Grecia',
      HR: 'Croazia',
      HU: 'Ungheria',
      IN: 'India',
      INTERNATIONAL: 'Internazionale',
      IS: 'Islanda',
      IT: 'Italia',
      LT: 'Lituania',
      LU: 'Lussemburgo',
      LV: 'Lettonia',
      MC: 'Monaco',
      MU: 'Mauritius',
      MX: 'Messico',
      NL: 'Paesi Bassi',
      PL: 'Polonia',
      PT: 'Portogallo',
      RO: 'Romania',
      RS: 'Serbia',
      SE: 'Svezia',
      SI: 'Slovenia',
      SK: 'Slovacchia'
    }
  },
  dashboard: {
    deactivated: {
      action: 'Contatti',
      message: 'La preghiamo di contattarci se desidera riattivare la sua sede e rinnovare la sua offerta.',
      title: 'La sua azienda è disattivata'
    },
    documents: 'Documenti',
    documentsToProcess: {
      action: {
        sign: 'Firmare questo documento',
        upload: 'Depositare questo documento'
      },
      emptyList: 'Tutti i tuoi documenti sono stati elaborati',
      expandList: 'Vedere tutti i documenti da elaborare',
      message: {
        AWAITING_SIGNATURE: 'deve essere firmato',
        EXPIRED: 'è scaduto da %{expirationDate}',
        MISSING: 'mancante',
        REJECTED: 'è stato respinto per il seguente motivo:'
      },
      title: 'Documenti da elaborare'
    },
    stats: {
      clients: 'Clienti',
      link: {
        clients: 'Vedi tutti gli clienti',
        projects: 'Vedi tutti gli operazioni',
        subcontractors: 'Vedi tutti gli fornitori',
        users: 'Vedi tutti gli utenti'
      },
      projects: 'Operazioni',
      subcontractors: {
        nationality: {
          FRANCE: 'francese',
          GERMANY: 'tedesca',
          ITALY: 'italiana'
        },
        title: 'Fornitori',
        valid: 'dei fornitori di questa azienda hanno una status del file %{nationality} valida'
      },
      users: 'Utenti'
    }
  },
  datetime: {
    datePickerMask: [
      'd',
      'd',
      '/',
      'd',
      'd',
      '/',
      'd',
      'd',
      'd',
      'd'
    ],
    shortDate: 'DD/MM/YYYY',
    shortDatetime: 'DD/MM/YYYY HH:mm',
    undefined: '-'
  },
  document: {
    addAdditionalDesignation: 'Aggiungere una denominazione supplementare',
    additionalDesignation: 'Denominazione supplementare',
    additionalDesignationNotice: 'Utilizzata per distinguere due documenti dello stesso tipo',
    additionalDesignationSuccessUpdate: 'La denominazione supplementare è stata aggiornata con successo',
    all: 'Tutti i documenti',
    canNotDownload: 'Questo documento non può essere scaricato.',
    changeFile: 'Cambiare il file',
    chart: {
      almostExpired: 'documenti con scadenza imminente',
      almostExpired_1: 'documento con scadenza imminente',
      awaiting: 'documenti in fase di elaborazione',
      awaiting_1: 'documento in fase di elaborazione',
      percentageLabel: 'Validi',
      seeMyDocuments: 'Vedere i miei documenti',
      title: 'Stato dei miei documenti',
      todo: 'documenti da elaborare',
      todo_1: 'documento da elaborare',
      valid: 'documenti validi',
      valid_1: 'documento valido'
    },
    checkFile: 'Verificare il documento',
    chooseOnComputer: 'Selezioni sul suo computer',
    collectionMandateEnabled: {
      FRANCE: 'Raccolto da Attestation Légale',
      GERMANY: 'Raccolto da OnceForAll',
      ITALY: 'Raccolto da OnceForAll'
    },
    consultMyArchivedDocuments: 'Consultare i miei archivi',
    consultMyDocuments: 'Ritorno ai documenti',
    delete: 'Cancellare',
    documentDetails: {
      addNewVersion: 'Aggiungere una nuova versione',
      documentExample: 'cliccare per vedere un modello del documento previsto',
      documentIsGathered: {
        FRANCE: 'Questo documento viene raccolto da Attestation Légale.',
        GERMANY: 'Questo documento viene raccolto da OnceForAll.',
        ITALY: 'Questo documento viene raccolto da OnceForAll.'
      },
      documentIsRejected: 'Il documento è stato rifiutato, faccia clic per avere maggiori dettagli.',
      documentVersionIsAwaitingSignature: 'Una versione del documento è in attesa di firma, faccia clic per avere maggiori dettagli.',
      documentVersionIsRejected: 'Una versione del documento è stata rifiutata, faccia clic per avere maggiori dettagli.',
      emptyTimeline: 'Questo documento non ha ancora una versione valida',
      noPastDocument: 'Nessun archivio per questo documento',
      noPresentDocument: 'Nessuna versione valida al momento',
      noPresentDocumentAtDate: 'No valid version at the project opening date: %{projectOpeningDate}',
      noPresentDocumentAtInterventionDate: "Non ci sono versioni valide alla data di inizio dell'intervento: %{interventionDate}",
      noPresentDocumentAtInterventionDateTooltip: "Lo staus del documento è calcolato sulla base dell'inizio dell'intervento, poiché l'organizzazione è stata creata successivamente alla data di apertura del cantiere.",
      showArchives: 'Visualizzare gli archivi di questo documento',
      showTimelineButton: 'Vedi tutte le versioni valide',
      state: {
        ALMOST_EXPIRED: 'Valido, scade %{time}',
        AWAITING_COMPLETION: 'In attesa di inserimento',
        AWAITING_GATHERING: 'In fase di raccolta',
        AWAITING_SIGNATURE: 'In attesa di firma',
        AWAITING_VALIDATION: 'In attesa di verifica',
        CREATED: 'Sconosciuto',
        EXPIRED: 'Scaduto %{time}',
        MISSING: 'Mancante',
        NOT_APPLICABLE: 'Non applicabile',
        REJECTED: 'Rifiutato',
        SIGNED: 'Firmato, valido%{until}',
        VALID: 'Valido%{until}'
      },
      timeline: 'Cronologia delle versioni del documento',
      unpublished: 'Documento archiviato',
      validityEndLineForValid: ' fino al %{validityEnd}'
    },
    documentType: 'Tipo di documento',
    documentVersion: {
      ongoingLabel: 'In corso',
      rejectionReason: ' Motivo : <span class="error">%{rejectionReason}</span>',
      state: {
        ALMOST_EXPIRED: '<strong class="warning">con scadenza imminente</strong>',
        AWAITING_GATHERING: '<strong class="ofa">in attesa di raccolta</strong>',
        AWAITING_SIGNATURE: '<strong class="error">in attesa di firma</strong>',
        AWAITING_VALIDATION: '<strong class="ofa">in attesa di verifica</strong>',
        EXPIRED: '<strong class="success">valida</strong>',
        MISSING: '<strong class="error">mancante</strong>',
        NOT_APPLICABLE: '<strong class="information">non applicabile</strong>',
        REJECTED: '<strong class="error">rifiutato</strong>. Motivo: <span class="error">%{rejectionReason}</span>',
        SIGNED: '<strong class="success">firmata e valida</strong>',
        VALID: '<strong class="success">valida</strong>'
      },
      stateLine: {
        CURRENT: 'Questa versione del documento è %{state}',
        FUTURE: 'Questa versione del documento sarà %{state}',
        PAST: 'Questa versione del documento era %{state}'
      },
      validityEndLine: ' fino al <strong>%{validityEnd}</strong>',
      validityFullLine: ' dal <strong>%{validityStart}</strong> al <strong>%{validityEnd}</strong>',
      validityStartLine: ' a partire da <strong>%{validityStart}</strong>'
    },
    dossierResume: {
      documentAlmostExpiredText: 'Il documento seguente scadrà presto: ',
      documentInvalidInProgressText: 'Un documento è in fase di elaborazione da parte di Attestation Légale.',
      documentInvalidText: 'Deve elaborare il documento seguente: ',
      documentsAlmostExpiredText: 'I documenti seguenti scadranno presto: ',
      documentsInvalidsInProgressText: 'Alcuni documenti sono in fase di elaborazione da parte di Attestation Légale.',
      documentsInvalidsText: 'Deve elaborare i documenti seguenti: ',
      download: 'Scaricare lo status del file',
      title: {
        AWAITING_VERIFICATION: 'Il suo status del file è in fase di verifica',
        INVALID: 'Il suo status del file non è valida',
        VALID: 'Il suo status del file è valida',
        WARNING: 'Il suo status del file è valida, ma scadrà presto'
      }
    },
    downloadExcelTemplate: 'Scaricare Il modello Excel',
    downloadExcelTemplateMessage: 'La preghiamo di cominciare scaricando il modello Excel',
    downloadTemplate: 'Scaricare il modello',
    downloadTemplateMessage: 'La preghiamo di cominciare scaricando il modello',
    dragDropHere: 'Faccia scorrere e depositi qui il suo documento',
    duplicate: 'Duplicare',
    editAdditionalDesignation: 'Modificare la denominazione supplementare',
    errorMaxSizeMessage: 'La dimensione massima è di %{count}MB',
    errorMinSizeMessage: 'La dimensione minima è di %{count}KB',
    errorTypeMessage: 'Il file deve essere nel o nei formati seguenti: ',
    fileSize: 'Dimensione del file',
    filename: 'Nome del file',
    foreignEmployees: {
      secondaryUploadMessage: 'Formati disponibili: Excel e PDF (Se scarica un documento PDF, il team di OnceForAll trascriverà questo elenco di dipendenti in un file Excel e lo scaricherà al suo posto.)',
      uploadMessage: {
        bullet1: 'I dipendenti dello Spazio Economico Europeo',
        bullet2: 'Gli interinali',
        line1: 'Non sono sottoposti a dichiarazione:',
        line2: 'Le informazioni fornite saranno verificate dal team di OnceForAll.\nLa preghiamo di verificare che le informazioni del suo documento siano corrette e sufficientemente leggibili.'
      }
    },
    header: {
      dossiers: 'Cartelle',
      name: 'Nome',
      reminderStatus: 'Stato al momento del sollecito',
      status: 'Status attuale',
      validityPeriod: 'Periodo di validità'
    },
    issueDate: 'Data di emissione',
    myArchivedDocuments: 'Archivi',
    myDocuments: 'Documenti',
    myTodoDocuments: 'Da elaborare',
    noArchive: 'Nessun archivio',
    noDocumentMessage: 'Al fine di poter depositare i suoi documenti, la preghiamo di aggiungere un cliente.',
    noForeignWorkers: 'Non ho dipendenti stranieri',
    noResultMatch: 'Nessun risultato corrisponde alla sua ricerca',
    noSignPermission: "Solo il responsabile legale dell'azienda può firmare questo documento",
    noTodo: 'Non ha documenti da depositare',
    notDepositor: 'Deve cambiare offerta per depositare dei documenti e invitare dei clienti.',
    open: 'Aprire',
    openExcel: 'Aprire il file Excel',
    openProof: "Aprire l'autenticazione",
    payrollRatio: {
      NC: 'Non riportato',
      label: 'Rapporto salariale:'
    },
    remind: {
      additionalContext: 'Precisi il contesto del suo sollecito',
      command: {
        title: 'Sollecitare il dossier'
      },
      context: 'Contesto',
      description: {
        additionalContext: 'Contesto aggiuntivo:',
        dateFrom: 'Domanda di sollecito del %{date}',
        emptyMessage: "Non c'è una domanda di sollecito",
        projectName: "Nome dell'operazione:",
        reason: {
          APPLICATION_APPROVAL: "Richiedere l'autorizzazione",
          CONTRACT: 'Conservare la cartelle aggiornata',
          CREATION_ADDITIONAL_DOCUMENT: 'Avere un documento complementare',
          END_OF_PROJECT: "Fine dell'operazione",
          PAYMENT: 'Pagare la fattura',
          PRIVATE_MARKET: 'Mercato privato',
          PUBLIC_MARKET: 'Mercato pubblico',
          REPORT_ANOMALY: "Correggere un'anomalia sui documenti",
          SIGNATURE: 'Firmare il contratto',
          title: 'Motivo:'
        }
      },
      documents: {
        error: 'Deve selezionare un documento',
        title: 'Documenti da sollecitare'
      },
      information: 'Se, nonostante i solleciti preventivi effettuati da Attestation Légale via e-mail e telefonici, il dossier non dispone dei documenti previsti, questo servizio le permette di attivare un sollecito telefonico del suo fornitore sulla base del contesto che ci comunica di seguito.<br /><br />La terremo informata personalmente del seguito dato a questa domanda.',
      reason: {
        APPLICATION_APPROVAL: "Richiedere l'autorizzazione",
        CONTRACT: 'Conservare la cartelle aggiornata',
        CREATION_ADDITIONAL_DOCUMENT: 'Avere un documento complementare',
        PAYMENT: 'Pagare la fattura',
        REPORT_ANOMALY: "Correggere un'anomalia sui documenti",
        SIGNATURE: 'Firmare il contratto',
        name: 'Motivo della mia domanda'
      },
      subMessageProject: "Nel quadro dell'operazione",
      subMessageReason: "desidero ottenere l'aggiornamento dei suoi documenti per",
      success: 'Il Sollecito Documentale è stato preso in considerazione. Riceverà una copia via e-mail.',
      title: 'Domanda di sollecito complementare'
    },
    searchArchiveBar: 'Nome del documento',
    searchBar: 'Nome del documento',
    seeExample: 'Vedere un esempio',
    sign: 'Firmare',
    signWaitingText: 'La preghiamo di attendere, sarà ridiretto verso il nostro fornitore di firma elettronica...',
    staff: 'Dipendenti:',
    state: {
      ALMOST_EXPIRED: 'Con scadenza imminente',
      AWAITING_COMPLETION: 'In attesa di inserimento',
      AWAITING_GATHERING: 'In fase di raccolta',
      AWAITING_SIGNATURE: 'In attesa di firma',
      AWAITING_VALIDATION: 'In attesa di verifica',
      CREATED: 'Sconosciuto',
      EXPIRED: 'Scaduto',
      MISSING: 'Mancante',
      NOT_APPLICABLE: 'Non applicabile',
      REJECTED: 'Rifiutato',
      SIGNED: 'Firmato',
      VALID: 'Valido'
    },
    upload: 'Depositare',
    uploadMessage: {
      FRANCE: 'Se il suo documento non è in __sfrancese__s, la preghiamo di depositare un file contenente il documento originale e la sua __straduzione__s in francese.',
      GERMANY: 'Se il suo documento non è in __stedesco__s, la preghiamo di depositare un file contenente il documento originale e la sua __straduzione__s in tedesco.',
      ITALY: 'Se il suo documento non è in __sitaliano__s, la preghiamo di depositare un file contenente il documento originale e la sua __straduzione__s in italiano.'
    },
    uploadSuccess: 'Il suo file è stato depositato con successo',
    uploadUpdate: 'Aggiornare',
    valid: 'Documenti validi',
    validityPeriod: 'Dal %{startDate} al %{endDate}',
    waiting: 'Documenti da depositare'
  },
  documentType: {
    search: {
      alreadyRequired: 'Questo tipo di documento è già richiesto',
      notfound: 'Questo tipo di documento non esiste',
      placeholder: 'Cercare un tipo di documento'
    }
  },
  dossier: {
    add: 'Aggiungere un documento',
    addLabel: 'Selezionare un documento',
    addSuccessful: 'Il documento è stato aggiunto con successo',
    countryLabel: 'Dossier ',
    download: {
      all: 'Scaricare il dossier',
      dossierOverview: 'Scaricare lo status del file',
      standard: 'Scaricare il dossier',
      standardArchives: 'Scaricare tutti gli archivi'
    },
    interoperated: 'Dossier condiviso tra piattaforme',
    labels: {
      ADDITIONAL: 'Aggiuntivo',
      BUSINESS: {
        ALL: 'Mestiere',
        CLEANING: 'Pulizia',
        CONSTRUCTION: 'Edilizia e lavori pubblici',
        SAFETY: 'Sicurezza privata',
        TEMPORARY_WORK: 'Lavoro temporaneo',
        TRANSPORTATION: 'Trasporti'
      },
      LEGAL: 'Obbligatorio',
      PROJECT: 'Operazioni'
    },
    print: {
      all: 'Stampare il dossier',
      standard: 'Stampare il dossier'
    },
    projects: 'Operazioni',
    relatedProjects: 'Operazioni associate',
    state: {
      AWAITING_VERIFICATION: {
        fullLabel: 'Status del file in fase di verifica',
        shortLabel: 'In fase di verifica'
      },
      DEPOSITOR_SERVICE_DEACTIVATED: {
        fullLabel: 'Servizio di deposito non attivato',
        shortLabel: 'Servizio di deposito non attivato'
      },
      EMPTY: {
        fullLabel: 'Nessun documento per il paese selezionato',
        shortLabel: 'Nessun documento per il paese selezionato'
      },
      INVALID: {
        fullLabel: 'Status del file non valida',
        shortLabel: 'Non valida'
      },
      UNKNOWN: {
        fullLabel: 'Lo stato dello status del file non è ancora disponibile',
        shortLabel: 'Non disponibile'
      },
      VALID: {
        fullLabel: 'Status del file valida',
        shortLabel: 'Valido'
      },
      WARNING: {
        fullLabel: 'Status del file valida, ma scadrà presto',
        shortLabel: 'Valida, ma scadrà presto'
      },
      title: 'Stato dello status del file'
    }
  },
  error: {
    CGURequired: 'Le CGU devono essere accettate',
    clientAlreadyExists: 'Impossibile aggiungere più di un committente, la preghiamo di verificare il suo inserimento',
    dateShouldBeBefore: 'Un intervento comincia prima della nuova data di apertura del cantiere !',
    emailConfirmation: "L'e-mail di conferma non corrisponde all'e-mail inserita",
    generic: 'Si è verificato un errore',
    interventionAlreadyEnded: 'Sei già collegato a questa azienda in questa operazione',
    invalidEmailFormat: "Il formato dell'e-mail è scorretto",
    invalidIdentificationNumber: 'Numero di identificazione non valido',
    invalidMobilePhoneNumber: 'Il formato del numero di telefono cellulare è scorretto',
    invalidNumberFormat: 'Questo campo deve contenere delle cifre',
    invalidPhoneNumber: 'Il formato del numero di telefono è scorretto',
    invalidRegistrationNumber: 'Numero di identificazione non valido',
    notYetSupported: 'Questa funzionalità non è ancora disponibile',
    organisationAlreadyExists: 'Sei già collegato a questa azienda in questa operazione',
    organisationNotFound: 'Nessuna azienda esiste con questo numero di Codice Fiscale',
    passwordConfirmation: 'La password di conferma non corrisponde alla password inserita',
    privacyPolicyRequired: "L'Informativa sulla privacy deve essere accettata",
    registrationNumberAlreadyExists: 'Questo numero di identificazione esiste già',
    required: 'Questo campo è obbligatorio',
    userAlreadyExist: 'Un account con questo indirizzo e-mail esiste già',
    validation: 'Il valore inserito non è valido'
  },
  errorPage: {
    contactEmail: 'contatto.it@onceforall.com',
    buttonLabel: 'Aggiornare la pagina',
    subtitle: "La preghiamo di scusarci, si è verificato un errore nell'applicazione. Stiamo tentando attualmente di risolvere il problema.",
    text: 'Se il problema permane, può contattarci a ',
    title: 'ERRORE'
  },
  favoriteRelationship: {
    add: 'Aggiungere ai Preferiti',
    message: {
      add: '%{organisationName} è stato aggiunto ai Preferiti',
      remove: '%{organisationName} è stato rimosso dai Preferiti'
    },
    remove: 'Rimuovere dai Preferiti'
  },
  globalDashboard: {
    documents: 'Documenti dei miei fornitori',
    documentsStillValid: 'ancora validi',
    myOrganisations: 'Le mie sedi',
    mySubcontractors: 'I miei fornitori',
    organisationRegistrationSuccessful: {
      line1: 'La sua domanda è in fase di elaborazione.',
      line2: "Sarà avvisato via e-mail una volta terminata l'elaborazione della sua domanda."
    },
    quitus: 'Status del file dei miei fornitori',
    quitusDescription: 'dei fornitori con uno status valido',
    seeAllSubcontractors: 'Vedere tutti i miei fornitori attivi',
    subcontractorsLabel: 'Fornitori attivi'
  },
  globalSubcontractor: {
    noSubcontractors: 'Nessun fornitore',
    selectClientForSubcontractor: 'Imprese correlate con il fornitore %{subcontractorName}:',
    title: 'Tutti i miei fornitori'
  },
  helpCenter: {
    aQuestion: 'Una domanda?',
    category: {
      ACCESS: 'Il mio accesso',
      CLIENT: 'I miei clienti',
      DOCUMENT: 'I miei documenti',
      MODEL: 'I miei modelli',
      OPTION: 'Le mie opzioni',
      PARAMETER: 'I miei parametri',
      PROJECT: 'Le mie operazioni',
      SUBCONTRACTOR: 'I miei fornitori'
    },
    contactCustomerService: 'Non hai trovato la sua risposta?',
    contactCustomerServiceLink: 'Contatta il servizio clienti.',
    helpCenterButton: 'Vedere la pagina Aiuto e Contatti',
    selectACategory: 'Selezionare una categoria:',
    title: 'Aiuto e Contatti'
  },
  identificationNumber: {
    ANDORRA: {
      REGISTRATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + Numero di 11 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + Numero di 11 cifre'
      }
    },
    AUSTRIA: {
      REGISTRATION_NUMBER: {
        name: 'Umsatzsteuer-Identifikationsnummer',
        tooltip: 'ATU + Numero di 8 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Umsatzsteuer-Identifikationsnummer (IVA intra)',
        tooltip: 'ATU + Numero di 8 cifre'
      }
    },
    BELGIUM: {
      REGISTRATION_NUMBER: {
        name: 'BTW identificatienummer / Numero di IVA',
        tooltip: 'BE + Numero di 10 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'BTW identificatienummer / Numero di IVA',
        tooltip: 'BE + Numero di 10 cifre'
      }
    },
    BOLIVIA: {
      REGISTRATION_NUMBER: {
        name: 'Número de Identificación Tributaria',
        tooltip: 'Numero da 8 a 12 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Número de Identificación Tributaria (IVA intra)',
        tooltip: 'Numero da 8 a 12 cifre'
      }
    },
    BULGARIA: {
      REGISTRATION_NUMBER: {
        name: 'Identifikacionen nomer po DDS',
        tooltip: 'BG + Numero di 9 o 10 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Identifikacionen nomer po DDS (IVA intra)',
        tooltip: 'BG + Numero di 9 o 10 cifre'
      }
    },
    CROATIA: {
      REGISTRATION_NUMBER: {
        name: 'PDV Id. Broj OIB',
        tooltip: 'HR + Numero di 11 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'PDV Id. Broj OIB (IVA intra)',
        tooltip: 'HR + Numero di 11 cifre'
      }
    },
    CZECH_REPUBLIC: {
      REGISTRATION_NUMBER: {
        name: 'Daňové identifikační číslo',
        tooltip: 'CZ + Numero da 8 a 10 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Daňové identifikační číslo (IVA intra)',
        tooltip: 'CZ + Numero da 8 a 10 cifre'
      }
    },
    DENMARK: {
      REGISTRATION_NUMBER: {
        name: 'Momsregistreringsnummer',
        tooltip: 'DK + Numero di 8 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Momsregistreringsnummer (IVA intra)',
        tooltip: 'DK + Numero di 8 cifre'
      }
    },
    ESTONIA: {
      REGISTRATION_NUMBER: {
        name: 'Käibemaksukohustuslase number',
        tooltip: 'EE + Numero di 9 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Käibemaksukohustuslase number (IVA intra)',
        tooltip: 'EE + Numero di 9 cifre'
      }
    },
    FRANCE: {
      GROUP_NUMBER: {
        name: 'SIREN',
        tooltip: 'Numero di 9 cifre'
      },
      REGISTRATION_NUMBER: {
        name: 'SIRET',
        tooltip: 'Numero di 14 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + Numero di 11 cifre'
      }
    },
    GERMANY: {
      REGISTRATION_NUMBER: {
        name: 'Betriebsnummer',
        tooltip: 'Numero di 8 cifre'
      },
      STEUERLICHE_IDENTIFIKATIONSNUMMER: {
        name: 'Steuerliche Identifikationsnummer',
        shortName: 'Steuernummer',
        tooltip: 'Numero di 11 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Umsatzsteuer-Identifikationsnummer (IVA intra)',
        shortName: 'Ust.-ID',
        tooltip: 'DE + Numero di 9 cifre'
      }
    },
    GREECE: {
      REGISTRATION_NUMBER: {
        name: 'Arithmós Forologikou Mētrṓou',
        tooltip: 'EL + Numero di 9 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Arithmós Forologikou Mētrṓou (IVA intra)',
        tooltip: 'EL + Numero di 9 cifre'
      }
    },
    HUNGARY: {
      REGISTRATION_NUMBER: {
        name: 'Közösségi adószám',
        tooltip: 'HU + Numero di 8 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Közösségi adószám (IVA intra)',
        tooltip: 'HU + Numero di 8 cifre'
      }
    },
    ICELAND: {
      REGISTRATION_NUMBER: {
        name: 'Virðisaukaskattsnúmer',
        tooltip: 'IS + Numero di 6 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Virðisaukaskattsnúmer (IVA intra)',
        tooltip: 'IS + Numero di 6 cifre'
      }
    },
    INDIA: {
      REGISTRATION_NUMBER: {
        name: 'Value Added Tax / Central Sales Tax TIN',
        tooltip: 'IN + Numero di 11 cifre + V'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Value Added Tax / Central Sales Tax TIN (IVA intra)',
        tooltip: 'IN + Numero di 11 cifre + V'
      }
    },
    ITALY: {
      REGISTRATION_NUMBER: {
        name: 'Codice Fiscale',
        tooltip: 'Numero con 11 cifre per le imprese o 16 caratteri per le persone'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Partita IVA (IVA intra)',
        tooltip: 'IT + Numero di 11 cifre'
      }
    },
    IVORY_COAST: {
      REGISTRATION_NUMBER: {
        name: 'VAT Identification Number',
        tooltip: 'CI + Numero di 9 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'VAT Identification Number (IVA intra)',
        tooltip: 'CI + Numero di 9 cifre'
      }
    },
    LATVIA: {
      REGISTRATION_NUMBER: {
        name: 'Pievienotās vērtības nodokļa (PVN) reģistrācijas numurs',
        tooltip: 'LV + Numero di 11 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Pievienotās vērtības nodokļa (PVN) reģistrācijas numurs (IVA intra)',
        tooltip: 'LV + Numero di 11 cifre'
      }
    },
    LITHUANIA: {
      REGISTRATION_NUMBER: {
        name: 'PVM (Pridėtinės vertės mokestis) mokėtojo kodas',
        tooltip: 'LT + Numero di 9 o 12 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'PVM (Pridėtinės vertės mokestis) mokėtojo kodas (IVA intra)',
        tooltip: 'LT + Numero di 9 o 12 cifre'
      }
    },
    LUXEMBOURG: {
      REGISTRATION_NUMBER: {
        name: 'Numéro d‘identification à la TVA',
        tooltip: 'LU + Numero di 8 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Numéro d‘identification à la TVA',
        tooltip: 'LU + Numero di 8 cifre'
      }
    },
    MAURITIUS: {
      REGISTRATION_NUMBER: {
        name: 'VAT Identification Number',
        tooltip: 'MU + Numero di 8 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'VAT Identification Number (IVA intra)',
        tooltip: 'MU + Numero di 8 cifre'
      }
    },
    MEXICO: {
      REGISTRATION_NUMBER: {
        name: 'Registro Federal de Contribuyentes',
        tooltip: '3 o 4-caratteri + 6 cifre + 3 caratteri'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Registro Federal de Contribuyentes (IVA intra)',
        tooltip: '3 o 4-caratteri + 6 cifre + 3 caratteri'
      }
    },
    MONACO: {
      REGISTRATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + Numero di 11 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + Numero di 11 cifre'
      }
    },
    NETHERLANDS: {
      REGISTRATION_NUMBER: {
        name: 'Btw-nummer',
        tooltip: 'NL + 9 cifre + B + 2 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Btw-nummer (IVA intra)',
        tooltip: 'NL + 9 cifre + B + 2 cifre'
      }
    },
    POLAND: {
      REGISTRATION_NUMBER: {
        name: 'Numer identyfikacji podatkowej',
        tooltip: 'PL + Numero di 10 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Numer identyfikacji podatkowej (IVA intra)',
        tooltip: 'PL + Numero di 10 cifre'
      }
    },
    PORTUGAL: {
      REGISTRATION_NUMBER: {
        name: 'Número de Identificação Fiscal / de Pessoa Coletiva',
        tooltip: 'PT + Numero di 9 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Número de Identificação Fiscal / de Pessoa Coletiva (IVA intra)',
        tooltip: 'PT + Numero di 9 cifre'
      }
    },
    ROMANIA: {
      REGISTRATION_NUMBER: {
        name: 'Codul de identificare fiscală',
        tooltip: 'RO + Numero da 2 a 10 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Codul de identificare fiscală (IVA intra)',
        tooltip: 'RO + Numero da 2 a 10 cifre'
      }
    },
    SERBIA: {
      REGISTRATION_NUMBER: {
        name: 'Poreski identifikacioni broj',
        tooltip: 'Numero di 9 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Poreski identifikacioni broj (IVA intra)',
        tooltip: 'Numero di 9 cifre'
      }
    },
    SLOVAKIA: {
      REGISTRATION_NUMBER: {
        name: 'Identifikačné číslo pre daň z pridanej hodnoty',
        tooltip: 'SK + Numero di 10 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Identifikačné číslo pre daň z pridanej hodnoty (IVA intra)',
        tooltip: 'SK + Numero di 10 cifre'
      }
    },
    SLOVENIA: {
      REGISTRATION_NUMBER: {
        name: 'Identifikacijska številka za DDV',
        tooltip: 'SI + Numero di 8 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Identifikacijska številka za DDV (IVA intra)',
        tooltip: 'SI + Numero di 8 cifre'
      }
    },
    SPAIN: {
      REGISTRATION_NUMBER: {
        name: 'Número de Identificación Fiscal',
        tooltip: 'ES + 1 carattere + 7 cifre + 1 carattere'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Número de Identificación Fiscal (IVA intra)',
        tooltip: 'ES + 1 carattere + 7 cifre + 1 carattere'
      }
    },
    SWEDEN: {
      REGISTRATION_NUMBER: {
        name: 'Momsregistreringsnummer',
        tooltip: 'SE + Numero di 12 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Momsregistreringsnummer (IVA intra)',
        tooltip: 'SE + Numero di 12 cifre'
      }
    },
    SWITZERLAND: {
      REGISTRATION_NUMBER: {
        name: 'Mehrwertsteuernummer',
        tooltip: 'CHE + Numero di 9 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Mehrwertsteuernummer (IVA intra)',
        tooltip: 'CHE + Numero di 9 cifre'
      }
    },
    UNITED_KINGDOM: {
      REGISTRATION_NUMBER: {
        name: 'Value added tax registration number',
        tooltip: 'GB + 9 o 12 cifre / GBGD + 3 cifre / GBHA + 3 cifre'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Value added tax registration number (IVA intra)',
        tooltip: 'GB + 9 o 12 cifre / GBGD + 3 cifre / GBHA + 3 cifre'
      }
    }
  },
  initialLoading: {
    error: "Spiacenti per l'attesa. I nostri sviluppattori stanno analizzando il problema",
    message: 'Vi preghiamo di attendere…'
  },
  intervention: {
    dateForm: {
      error: 'La data non può essere precedente alla data di apertura del progetto',
      fieldLabel: 'Data',
      openButton: 'Fissare una data di intervento',
      saveSuccess: 'La data di intervento è stata registrata',
      title: 'Fissare una data di intervento'
    },
    ended: {
      buttonTitle: "Terminare l'intervento di questa impresa",
      confirmEndOrganisation: {
        content: 'È certo di voler terminare la partecipazione di %{organisationName} al progetto?',
        warning: 'Questa impresa e i suoi subappaltatori non potranno più accedere al progetto'
      },
      endSuccess: "%{organisationName} non fa più parte dell'operazione",
      name: ' (terminato)',
      tooltip: "L'intervento di questa impresa è stato terminato il %{endDate}"
    },
    invited: {
      external: {
        CLIENT: 'In attesa di iscrizione da parte del committente',
        GENERAL_CONTRACTOR: "In attesa di iscrizione da parte dell'azienda principale",
        PROJECT_MANAGER: 'In attesa di iscrizione da parte del Direttore dei lavori',
        PROJECT_MANAGER_CLIENT: 'In attesa di iscrizione da parte del Direttore dei lavori',
        SERVICE_PROVIDER: 'In attesa di iscrizione da parte del prestatore',
        SUB_CONTRACTOR: 'In attesa di iscrizione da parte del cliente'
      },
      internal: {
        CLIENT: 'In attesa di accettazione da parte del committente',
        GENERAL_CONTRACTOR: "In attesa di accettazione da parte dell'azienda principale",
        PROJECT_MANAGER: 'In attesa di accettazione da parte del Direttore dei lavori',
        PROJECT_MANAGER_CLIENT: 'In attesa di accettazione da parte del Direttore dei lavori',
        SERVICE_PROVIDER: 'In attesa di accettazione da parte del prestatore',
        SUB_CONTRACTOR: 'In attesa di accettazione da parte del subappaltatore'
      }
    },
    organisationDeactivated: '(Impresa disattivata)',
    removed: {
      removeSuccess: "L'azienda %{organisationName} è stata cancellata con successo"
    },
    role: {
      CLIENT: 'Committente',
      GENERAL_CONTRACTOR: 'Azienda principale',
      PROJECT_MANAGER: 'Direttore dei lavori',
      PROJECT_MANAGER_CLIENT: 'Direttore dei lavori',
      SERVICE_PROVIDER: 'Prestatore',
      SUB_CONTRACTOR: 'Subappaltatore'
    }
  },
  invalidOrganisationDocuments: {
    emptyMessage: 'Nessun documento non valido da visualizzare',
    title: 'Documenti non validi'
  },
  invitation: {
    externalInvitationSuccessTitle: 'Invito inviato!',
    received: {
      actions: {
        accept: 'Accettare questo invito',
        reject: 'Rifiutare questo invito'
      },
      emptyList: 'Non avete inviti da elaborare',
      expandList: 'Vedi tutti gli inviti',
      message: {
        PROJECT_NOT_AUTOMATICALLY_ACCEPTED: "È invitato ad unirsi all'operazione __s%{projectName}__s",
        RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED: 'Lei è invitato da __s%{invitingOrganisationName}__s ad unirsi alla sua rete in qualità di fornitore.',
        RELATIONSHIP_SUGGESTED: 'Come fornitore in subappalto, potrebbe essere interessato a condividere i suoi documenti con __s%{invitingOrganisationName}__s',
        USER_PENDING: "L'utente __s%{firstName} %{lastName}__s ha chiesto di unirsi alla sua impresa.",
        projectInvitedBy: 'Invitato da __s%{invitingOrganisationName}__s'
      },
      title: 'Inviti ricevuti'
    },
    sent: {
      clone: "L'utente ha registrato l'organizzazione %{cloneRegistrationNumber} in seguito al tuo invito inviato all'organizzazione %{originalRegistrationNumber}",
      email: 'E-Mail',
      invitationDate: 'Ricevuta il',
      invitationSentDate: 'Inviata il',
      noResult: 'Nessun invito da visualizzare',
      resentOn: 'Rimandata il %{date}',
      status: 'Stato',
      waitingForApproval: 'In attesa di accettazione da parte del subappaltatore',
      waitingForRegistration: {
        client: 'In attesa di iscrizione da parte del cliente',
        subcontractor: 'In attesa di iscrizione da parte del subappaltatore'
      }
    },
    suggestion: {
      accept: 'Condividerà i documenti con',
      actions: {
        accept: 'Condividerà i documenti con %{invitingOrganisationName}',
        reject: 'Lei non vuole condividere i suoi documenti con %{invitingOrganisationName}'
      },
      expandList: 'Vedi tutti i suggeriment',
      reject: 'Lei non vuole condividere i suoi documenti con',
      rejectionReason: 'Prego selezioni una ragione di rifiuto del suggerimento',
      rejectionSuccess: '[%{invitingOrganisationName} has been removed from your clients suggestions!]',
      title: "I suggerimenti sono basati sugli inviti che hai ricevuto via email ma invitando un'organizzazione diversa dalla tua"
    }
  },
  invite: {
    alreadyExists: {
      action: 'Aggiungere',
      text: 'Puoi aggiungerlo direttamente',
      title: 'Questa azienda è già registrata nella rete OnceForAll'
    },
    alreadyInvited: {
      text: 'Hai già inviato un invito a questo indirizzo email per far aggiungere questa azienda alla rete OnceForAll.',
      title: 'Questo invito esiste già'
    },
    cancel: "Cancellare l'invito",
    cancelSuccessful: 'Il suo invito è stato cancellato.',
    customMessage: 'Messaggio',
    email: 'Indirizzo e-mail',
    firstName: 'Nome',
    inactive: {
      text: 'La preghiamo di contattare il nostro servizio clienti per maggiori informazioni.',
      title: 'Questa azienda è inattiva'
    },
    language: 'Lingua',
    lastName: 'Cognome',
    messageSectionSubtitle: 'Uoi mantenere il messaggio precompilato o modificarlo',
    messageSectionTitle: "Messaggio dell'invito",
    organisationName: 'Azienda',
    organisationSectionTitle: 'Quale azienda vorresti invitare?',
    phoneNumber: 'Numero di telefono',
    unknown: {
      text: 'Puoi invitare questa organizzazione a unirsi al Network OnceForAll.',
      title: 'Sembra che non esistano organizzazioni con questa Partita IVA'
    },
    userSectionTitle: 'A chi dobbiamo estendere questo invito?'
  },
  invoices: {
    amountDue: 'Importo dovuto',
    amountTotal: 'Importo totale',
    creationDate: 'Emessa il %{date}',
    download: 'Scaricare la fattura',
    dueOn: 'Data di scadenza il %{date}',
    loadMore: 'Visualizzare le 10 fatture seguenti',
    noResult: 'Nessuna fattura disponibile',
    paidOn: 'Pagata il %{date}',
    sentTo: 'Inviata a',
    status: {
      NOT_PAID: 'Da pagare',
      PAID: 'Pagata',
      PAYMENT_DUE: 'Da pagare',
      POSTED: 'Da pagare'
    },
    statusTitle: 'Stato',
    tabDisabled: 'Solo il manager può accedere alle fatture',
    title: 'Fatture'
  },
  language: {
    de: 'Deutsch',
    en: 'English',
    fr: 'Français',
    it: 'Italiano'
  },
  mandate: {
    details: {
      backToList: 'Ritorna alla lista dei mandati',
      details: {
        certifyingThirdParty: 'Terzo di certificazione',
        creationDate: 'Data di creazione',
        documentType: 'Tipologia documento',
        perimeter: {
          GROUP: 'Gruppo',
          ORGANISATION: 'Società',
          label: 'Mandato perimetrale'
        },
        title: 'Dettagli',
        updateDate: 'Data di modifica'
      },
      editMessage: {
        broadcast: 'Per modificare i dettagli del mandato di trasmissione, la preghiamo di',
        collection: 'Per modificare i dettagli del mandato di ritiro, la preghiamo di'
      },
      information: {
        broadcast: 'Invia le informazioni',
        collection: 'Raccolta di informazioni',
        copyToClipboard: 'Copia',
        showValue: 'Mostra valore',
        website: 'Sito internet'
      },
      title: {
        broadcast: 'Mandato di trasmissione per',
        collection: 'Mandato di raccolta per'
      }
    },
    field: {
      CONVENTION_NUMBER: 'Numero di convenzione',
      EMAIL: 'Indirizzo mail',
      FIRST_NAME: 'Nome',
      INSURANCE_COMPANY: 'Società - Agente - Broker',
      KEY: 'Chiave',
      LAST_NAME: 'Cognome',
      LOGIN: 'Nome utente',
      PASSWORD: 'Password',
      PHONE: 'Numero di telefono',
      POLICE_NUMBER: 'Numero di polizza',
      REGION: 'Provincia',
      REGISTRATION_NUMBER: 'P. IVA',
      SOCIAL_SECURITY_NUMBER: 'Codice fiscale'
    },
    list: {
      comment: 'Commenti',
      creationDate: 'Data di creazione',
      message: {
        email: 'servizio.clienti@onceforall.com',
        firstPart: {
          broadcast: {
            part1: "Il mandato di trasmissione è un'opzione già inclusa nel vostro abbonamento che ci permette di trasmettere documenti(1) validi della vostra organizzazione su altre piattaforme. Con il mandato di trasmissione, vi concentrate sulla vostra attività.",
            part2: "(1) Il documento \"Liste des salariés étrangers soumis à autorisation de travail\" non può essere aggiornato. Il documento \"Attestation fiscale\" deve essere modificato per l'anno in corso. Documenti specifici richiesti dai clienti, non disponibili sulla nostra piattaforma, devono essere aggiornati dalla vostra organizzazione."
          },
          collection: "Il mandato di riscossione è un'opzione già inclusa nel vostro abbonamento, ad eccezione del piano Expérience, che ci permette di gestire l'aggiornamento dei vostri documenti in Attestation Légale. Con il mandato di riscossione, vi concentrate sulla vostra attività."
        },
        link: 'cliccando qui',
        secondPart: 'Come si procede ? Scarica il documento ',
        thirdPart: ' e invia il documento compilato e firmato a '
      },
      noResult: {
        broadcast: 'Nessun mandato di trasmissione per questa società',
        collection: 'Nessun mandato di raccolta per questa società'
      },
      platform: 'Piattaforma',
      subtype: 'Tipologia documento',
      thirdParty: 'Terzo di certificazione',
      updateDate: 'Data di modifica'
    },
    planUpgradable: 'La tua offerta attuale deve essere aggiornata per trasmettere i documenti su altre piattaforme.',
    platform: {
      AWS: 'AWS',
      EATTESTATIONS: 'e-Attestations',
      MYPROCUREMENT: 'MyProcurement',
      PROVIGIS: 'Provigis'
    },
    platformWebsite: 'Aprire il sito web della piattaforma',
    thirdPartyGroup: {
      CIBTP: 'Ferie maltempo lavori',
      CNETP: 'Cassa nazionale degli imprenditori di lavori pubblici',
      NET_ENTREPRISE: 'Net azienda',
      PROBTP: 'Protezione sociale lavoratori della costruzione',
      TESE: 'Voucher per lavori',
      URSSAF: 'Sicurezza sociale',
      URSSAF_AUTOENT: 'Sicurezza sociale imprenditore',
      URSSAF_INDEP: 'Sicurezza sociale indipendente'
    },
    thirdPartyWebsite: 'Aprire sito web del terzo di certificazione'
  },
  menu: {
    bdr: '[Bâtisseur de Relations]',
    clients: 'Clienti',
    dashboard: 'Dashboard',
    documents: 'Documenti',
    help: 'Aiuto e Contatti',
    home: 'Pannello degli strumenti',
    news: '[]',
    panda: '[Access PanDA]',
    profile: 'Il mio profilo',
    projects: 'Operazioni',
    settings: 'Parametri',
    subcontractors: 'Fornitori',
    vitrine: '[Create my references list]'
  },
  message: {
    changesSaved: 'Le modifiche sono state salvate!',
    exportRequestSuccess: 'La sua domanda è stata salvata con successo. Riceverà presto la sua esportazione via e-mail.',
    lastUpdateDate: 'Data di ultima modifica:',
    loading: 'Caricamento in corso',
    missingPermission: "Non dispone dell'autorizzazione richiesta per firmare questo documento",
    missingRequiredFields: 'Tutti i campi obbligatori devono essere compilati',
    missingSelectedOrganisation: "Deve selezionare un'azienda",
    moreResults: '%{results} altri risultati',
    noData: 'Questi dati non sono ancora disponibili',
    pageAccessDenied: 'Siamo spiacenti, non ha accesso a questa pagina.',
    pageNotFound: 'Siamo spiacenti, impossibile trovare la pagina che ha chiesto.',
    projectNotEditable: 'Per modificare i campi disattivati, la preghiamo di',
    roleNotAllowed: 'Il suo ruolo non le permette di accedere a questa sezione. La preghiamo di contattare il servizio commerciale per modificarlo.',
    selectedOrganisationDenied: "Non ha accesso a questa azienda, ma la sua domanda è stata inviata ai manager dell'azienda",
    textCounter: '%{counter} caratteri su %{maxLength}'
  },
  notification: {
    document: {
      collectionMandateDisabled: {
        FRANCE: 'Il documento %{documentName} non viene più raccolto da Attestation Légale',
        GERMANY: 'Il documento %{documentName} non viene più raccolto da OnceForAll',
        ITALY: 'Il documento %{documentName} non viene più raccolto da OnceForAll'
      },
      created: '%{documentName} è stato aggiunto nel suo dossier.',
      depositor: 'Adesso può depositare dei documenti e condividerli con i suoi clienti.',
      remind: '%{userFullName} le ricorda di aggiornare i suoi documenti per la sua azienda %{organisationName}',
      requalified: '%{previousDocumentName} è stato rinominato %{documentName} dal nostro team',
      validated: 'Il documento %{documentName} è stato convalidato dal nostro team. Sarà valido fino al %{expirationDate}.',
      yourDocument: 'Il suo documento __s%{documentName}__s'
    },
    emptyList: 'Ha elaborato tutte le sue notifiche',
    organisation: {
      automaticAcceptationEnabled: 'Lei accetta gli inviti automaticamente in qualità di fornitore. Può modificare questo parametro per accettarli manualmente.',
      deactivation: {
        inviting: '%{organisationName} non può unirsi alla sua rete perché questa azienda è stata disattivata.',
        relatedAsClient: '%{organisationName} è stato disattivato. Può ancora accedere al suo dossier.',
        relatedAsSubcontractor: '%{organisationName} è stato disattivato.'
      }
    },
    project: {
      accepted: "Si è unito all'operazione %{projectName}",
      closed: "L'operazione %{projectName} è stata chiusa dall'azienda %{organisationOwnerName}. Può ancora accedere ai documenti relativi a questa operazione.",
      organisationEnded: "La sua azienda %{invitedOrganisationName} non fa più parte dell'operazione %{projectName}.",
      rejected: "L'azienda %{invitedOrganisationName} ha rifiutato di unirsi all'operazione %{projectName} perché: %{rejectionReason}",
      updatedRequiredDocumentsInProjectDossierOverview: "I documenti richiesti per lo status del file relativa all'operazione %{projectName} sono cambiati. "
    },
    relationship: {
      accepted: {
        AS_CLIENT: 'Si è unito alla rete di %{invitingOrganisationName} in qualità di cliente.',
        AS_SUBCONTRACTOR: 'Si è unito alla rete di %{invitingOrganisationName} in qualità di fornitore.'
      },
      rejected: "L'azienda %{invitedOrganisationName} ha rifiutato di unirsi alla sua rete perché: %{rejectionReason}"
    },
    user: {
      linked: '%{firstName} %{lastName} si è unito a %{organisationName}.',
      permissionsUpdated: {
        MANAGE_PROJECT: {
          ADDITION: '%{firstName} %{lastName} adesso può gestire delle operazioni per %{organisationName}',
          DELETION: '%{firstName} %{lastName} non può più gestire operazioni per %{organisationName}'
        },
        SIGN: {
          ADDITION: '%{firstName} %{lastName} adesso può firmare dei documenti online per %{organisationName}',
          DELETION: '%{firstName} %{lastName} non può più firmare documenti online per %{organisationName}'
        }
      },
      roleUpdated: {
        CONSULTANT: '%{firstName} %{lastName} ha ora il ruolo di Consulente per %{organisationName}',
        EXPLORER: '%{firstName} %{lastName} ha ora il ruolo di Esploratore per %{organisationName}',
        INVITING: '%{firstName} %{lastName} ha ora il ruolo di Responsabile inviti per %{organisationName}',
        MANAGER: '%{firstName} %{lastName} ha ora il ruolo di Responsabile clienti per %{organisationName}'
      }
    }
  },
  opera: {
    'platform-ACTRADIS': {
      message: 'Piattaforma master: ACTRADIS'
    },
    'platform-OFA': {
      message: 'Piattaforma master: OFA'
    }
  },
  organisation: {
    accessCode: {
      name: 'Codice di accesso',
      tooltip: 'Collegatevi direttamente con il vostro fornitore utilizzando il codice che vi ha fornito'
    },
    businessLine: {
      AGRICULTURE: 'Agricoltura',
      CLEANING: 'Pulizia',
      CONSTRUCTION: 'Costruzione',
      MANUFACTURING: 'Attività Manifatturiere',
      METAL_PRODUCTS: 'Manutenzione e installazione',
      OTHER: 'Altro settore',
      PARCEL_DELIVERY: 'Consegna pacchi',
      RENTAL_LEASING: 'Noleggio',
      SAFETY: 'Sicurezza privata',
      SERVICE_ACTIVITIES: 'Attività di servizi',
      TEMPORARY_WORK: 'Lavoro temporaneo',
      TRANSPORTATION: 'Trasporti',
      WASTE_MANAGEMENT: 'Rifuiti',
      title: 'Settore di attività'
    },
    create: {
      cautionNotice: 'Se desidera depositare i suoi documenti online, si assicuri di indicare correttamente la sede con la quale ha stipulato il contratto con il suo cliente.',
      errors: {
        sirenNotMatching: 'Il SIREN non corrisponde al SIRET inserito'
      },
      privacyPolicyAccepted: "Ho letto e accetto l'Informativa sulla privacy *",
      requiredNotice: '* Campi obbligatori',
      step1: 'Fase 1',
      step1Text: 'Inserisca il %{idNumberName} della sua azienda',
      step2: 'Fase 2',
      step2Text: 'Verificare o completare le informazioni',
      termsAccepted: 'Accetto le condizioni di utilizzo *',
      title: 'Inserire la mia azienda'
    },
    createOrganisation: "Selezionare un'azienda",
    createOrganisationDeactivated: '%{organisationName} è disattivata. Non può unirsi a questa azienda.',
    createOrganisationFound: 'Questa azienda esiste già su OnceForAll. Faccia clic su "Continua" per unirsi ad essa.',
    createOrganisationFoundAndLinked: "Impresa già esistente. Cliccare su \" Continuare\" se formi parte dell'impresa",
    createOrganisationFoundInILG: 'Questa azienda non esiste ancora su OnceForAll. La crei cliccando su "Continua".',
    createOrganisationNotFound: 'Impresa non trovata. La preghiamo di verificare il suo Codice Fiscale.',
    createOrganisationSuccess: 'La tua azienda è stato creata',
    deactivated: {
      title: 'Impresa disattivata',
      tooltip: 'Questa azienda è disattivata, non può selezionarla.',
      tooltipBackOffice: 'Questa azienda è disattivata.'
    },
    delete: {
      confirmDeleteOrganisation: {
        content: 'È certo di voler cancellare %{organisationName}?',
        warning: {
          client: 'Questa impresa non vedrà più i suoi documenti.',
          subcontractor: 'Non potrà più vedere i suoi documenti.'
        }
      },
      success: "L'impresa %{organisationName} è stata cancellata con successo",
      title: 'Cancellare dal mio elenco',
      tooltip: "Non può cancellare questa impresa perché condivide almeno un'operazione con essa. Solo il proprietario di un'operazione può cancellare un'impresa da un'operazione!"
    },
    depositorService: {
      noFile: 'Nessun file da scaricare',
      notActivated: 'Questa azienda non può più depositare documenti.'
    },
    details: "Dettagli dell'azienda",
    fullName: 'Ragione sociale',
    inactive: 'Questa azienda è inattiva. La preghiamo di contattare il nostro servizio clienti per maggiori informazioni.',
    invite: "Invitare l'impresa \"%{input}\" ad unirsi alla rete",
    registrationNumber: 'Numero di Codice Fiscale',
    remainingUserAccounts: '%{count} utenti restanti',
    search: {
      alreadyClient: 'Questa azienda fa già parte dei vostri clienti',
      alreadyInvited: 'Ha già invitato questo fornitore',
      alreadyPartOfProject: "Questa azienda fa già parte dell'operazione",
      alreadySelected: 'Questa azienda è già selezionata',
      alreadySubcontractor: 'Questa azienda fa già parte dei vostri fornitori',
      inputLabel: "Cercare un'azienda",
      invite: {
        action: 'Invitare',
        text: 'Puoi invitarli ad unirsi alla rete OnceForAll',
        title: "Non riesci a trovare l'azienda che stai cercando?"
      },
      lastSelected: 'Ultime organizzazioni consultate:',
      notfound: 'Questa azienda non ha ancora un account su OnceForAll',
      placeholder: 'Ragione sociale, Codice Fiscale o Partita IVA',
      self: 'Non aggiunga se stesso!',
      specifySearch: 'Potrebbero esserci più di 10 risultati. Precisi la sua ricerca.'
    },
    selectOrganisation: {
      all: 'Tutte le sue aziende',
      showAll: 'Vedere tutte le aziende',
      title: "Cercare un'azienda"
    },
    users: {
      noResult: {
        line1: "L'utente che stai cercando non appartiene a questa azienda.",
        line2: 'Volete invitarlo?'
      },
      searchLabel: 'Ricerca di un utente',
      title: 'Utenti'
    },
    viewDetails: 'Vedere i dettagli',
    website: 'Sito web'
  },
  organisationSetting: {
    cantEditMessage: "Per modificare i dettagli dell'azienda, la preghiamo di",
    cantModifyRole: 'Per modificare il ruolo e le autorizzazioni degli utenti, la preghiamo di',
    contactCustomerService: 'contattare il servizio clienti',
    detailsTitle: 'Profilo della mia azienda',
    mandates: {
      broadcast: {
        notDepositor: 'Per accedere ai mandati di trasmissione è necessario il servizio di depositario attivo',
        notManager: "Solo l'Account Manager può accedere ai mandati di trasmissione",
        title: 'Mandati di Trasmissione'
      },
      collection: {
        notDepositor: 'Per accedere ai mandati di Incasso è necessario il servizio di depositario attivo',
        notManager: "Solo l'Account Manager può accedere ai mandati di incasso",
        title: 'Mandati di Incasso'
      }
    },
    subscriptionAndInvoicesTabDisabled: "Solo l'account manager può gestire l'abbonamento e accedere alle fatture",
    subscriptionAndInvoicesTitle: 'Offerte e fatture',
    upload: 'Depositare',
    uploadLogo: "Depositare il logo dell'azienda",
    usersTitle: 'Utenti'
  },
  pagination: {
    items: 'Elementi',
    of: 'su',
    to: 'a'
  },
  panda: {
    access: {
      confirm: '[Access PanDA]',
      text1: '[You want to access PanDA.]',
      text2: '[PanDA platform allows you to simplify and secure the approvment of your subcontractors.]',
      text3: '[In just a few clicks, dematerialize the entire process of approving subcontractors working on your sites.]',
      text4: '[More information about PanDA]',
      text5: '[By clicking on "Access PanDA", your user account and your companies on OnceForAll platform will be automatically synced to PanDA.]'
    },
    discover: {
      cancel: 'Non voglio gestire le mie richieste di approvazione tramite PanDA',
      cta: 'Scoprire PanDA',
      text1: '__sGestite le richieste di approvazione online.__s',
      text2: 'Avete creato e gestite la vostra operazione sulla piattaforma Once for All. Perché non dematerializzare anche le vostre richieste di approvazione con la soluzione PanDA?'
    }
  },
  plan: {
    actions: {
      add: '   Aggiungere delle opzioni',
      contactUs: 'Contattaci',
      upgrade: 'Cambiare offerta'
    },
    currentPlan: 'La sua offerta attuale',
    free: 'GRATUITO',
    message: {
      upgradeSuccess: 'Il suo cambio di offerta è stato preso in considerazione. Sarà ricontattato prossimamente dal servizio clienti.'
    },
    modal: {
      additionalProjects: 'Operazioni supplementari',
      additionalProjectsOption: 'pagamento unico, durata illimitata',
      additionalUsers: 'Utenti supplementari',
      depositorService: 'Permettere a tutti i miei clienti di accedere ai miei documenti',
      title: "Aggiungere delle opzioni all'offerta %{type}"
    },
    options: {
      projectInclude: 'Operazioni incluse',
      userInclude: 'Utenti inclusi'
    },
    perMonth: '/ mese',
    specialPrice: '*19€ per le piccole aziende'
  },
  project: {
    actionProjectClosed: 'Questa azione è impossibile perché questa operazione è stata chiusa',
    additionalNotes: 'Descrizione',
    additionalNotesInfo: "Questa descrizione è visibile ad ogni azienda partecipante all'operazione",
    address: "Indirizzo dell'operazione",
    backToDashboard: "Ritorno al pannello di controllo dell'operazione",
    backToProjects: "Ritorno all'elenco delle operazioni",
    buttonDocuments: {
      download: 'Scaricare il dossier operazione',
      expand: {
        tooltip: 'Deve attivare il servizio di deposito per poter vedere il suo elenco di documenti'
      },
      print: 'Stampare il dossier operazione',
      showDocuments: 'Visualizzare i documenti'
    },
    close: "Chiudere l'operazione",
    closeSuccess: 'Questa operazione adesso è chiusa.',
    closedProject: '(chiusa)',
    closingDate: 'Data di chiusura',
    confirmProjectClosure: {
      content: 'Gli stati e i documenti delle aziende partecipanti restano accessibili.\nTuttavia, non potrà più invitare nuovi partecipanti a questa operazione e tutti gli inviti in corso saranno annullati.',
      title: 'È certo di voler chiudere questa operazione?',
      warning: "Questa azione è irreversibile, un'operazione non può essere riaperta!"
    },
    create: {
      button: 'Aggiungere una nuova operazione',
      creationSuccess: "L'operazione %{name} è stata creata!",
      projectCreditsTooltip: 'Non ha più crediti, la preghiamo di contattare il servizio clienti per acquistare nuovi crediti',
      title: 'Aggiungere una nuova operazione'
    },
    creditsNominative: '__s%{count}__s crediti operazione nominativa restanti',
    creditsNominative_0: '__s%{count}__s credito operazione nominativa restante',
    creditsNominative_1: '__s%{count}__s credito operazione nominativa restante',
    creditsStandard: '__s%{count}__s crediti operazione standard restanti',
    creditsStandard_0: '__s%{count}__s credito operazione standard restante',
    creditsStandard_1: '__s%{count}__s credito operazione standard restante',
    description: {
      notice: "Potrà modificare queste informazioni dopo la creazione dell'operazione",
      requiredNotice: '* Campi obbligatori',
      title: "Descrizione dell'operazione"
    },
    details: 'Dettagli',
    documentAtDateMessage: 'Il documento depositato deve essere valido alla data di apertura del cantiere: __s%{date}__s',
    documentAtInterventionDateMessage: 'Il documento depositato deve essere valido alla data di inizio del cantiere: __s%{interventionDate}__s',
    documents: 'Documenti',
    documentsStates: {
      ALMOST_EXPIRED: 'Con scadenza imminente',
      MISSING: 'Mancanti / Scaduti / Rifiutati',
      VALID: 'Validi'
    },
    documentsStillValid: 'ancora validi',
    edit: {
      addOrganisation: "Aggiungere un'azienda",
      addOrganisationExternalSuccess: "Un invito è stato inviato a l'azienda %{name}",
      addOrganisationInternalSuccess: "L'azienda %{name} è stato invitato ad unirsi all'operazione!",
      changeOrganisation: "Cambiare l'impresa",
      changeRole: 'Cambiare ruolo',
      descriptionsPerRole: {
        CLIENT: "<span>L'impresa per la quale viene eseguita l'operazione. Impresa o titolare per la quale è creata l'operazione.</span>",
        GENERAL_CONTRACTOR: "<span>Si tratta di un'azienda che si è aggiudicata un contratto per lavorare all'operazione. Questa società ha un rapporto contrattuale diretto con il Committente. Viene chiamata Azienda Principale quando l'operazione è in modalità \"maestranze specializzate separate\" o Azienda Generale quando tutti i lavori di tutte le specialità senza distinzione di categoria vengono assegnati ad essa.</span>",
        PROJECT_MANAGER: "<span>Si tratta di un'azienda che svolge degli studi e/o che fornisce assistenza al Committente (ufficio di progettazione, architetto, ecc.). Questa società ha un rapporto contrattuale diretto con il Committente.</span>",
        PROJECT_MANAGER_CLIENT: "<span>Si tratta di un'azienda che svolge degli studi e/o che fornisce assistenza al Committente (ufficio di progettazione, architetto, ecc.). Questa società ha un rapporto contrattuale diretto con il Committente.</span>",
        SERVICE_PROVIDER: "<span>Si tratta di un'azienda che esegue delle prestazioni per conto del Committente, del Direttore dei lavori o di un'Azienda Principale e le cui prestazioni non partecipano direttamente alla costituzione dell'opera. È titolare di un contratto di prestazione.</span>",
        SUB_CONTRACTOR: "<span>Si tratta di un'azienda che esegue dei lavori per conto di un'Azienda Principale o di un'Azienda Generale. È titolare di un contratto di subappalto. In base al suo livello di intervento, può avere un rapporto contrattuale con un'Azienda Principale o un Subappaltatore.</span>"
      },
      editDocuments: 'Applicare le modifiche',
      editProjectDescription: "Modificare la descrizione dell'operazione",
      editProjectDescriptionSuccess: "L'operazione %{name} è stata editata!",
      editRequiredDocuments: 'Modificare i documenti richiesti',
      externalInvitationSuccess: "Una volta che l'utente invitato si registra su OnceForAll e aggiunge la sua organizzazione, questa sarà automaticamente aggiunta all'operazione.",
      message: {
        EXTERNAL: 'Invito via e-mail',
        INTERNAL: 'Messa in relazione'
      },
      notEditable: "Deve prima depositare il capitolato d'oneri al fine di richiedere questo documento. Da quel momento, il servizio clienti creerà questo documento nel più breve tempo possibile.",
      organisation: "Scegliere un'impresa",
      requiredForDossierOverviewStatus: "Richiesti per lo status del file relativa all'Operazione",
      requiredForProject: 'Richiesto per questa operazione',
      roleAs: 'In qualità di',
      roleType: 'Selezionare un ruolo',
      seeRequiredDocuments: 'Vedere i documenti richiesti',
      title: "Aggiungere un'azienda",
      warning: '<strong>Attenzione:</strong> Se modifichi la data di apertura del progetto, tutte le certificazioni decennali alla data di apertura del progetto verranno ricalcolate. Assicurati di essere sicuro della modifica prima di confermare, per evitare eventuali errori.'
    },
    exportDossier: 'Esportare dossier operazione',
    exportQuitus: "Scaricare il rapporto sullo stato dei documenti raccolti relativi all'operazione",
    goToChart: "Vedere l'organigramma",
    grantAccess: {
      button: 'Dare accesso a questa operazione',
      missing: "Se non riesci a trovare l'utente nell'elenco, puoi aggiungerlo in un secondo momento contattando il tuo account manager o il ",
      missingLink: 'servizio clienti.',
      title: 'Dare accesso a questa operazione',
      user: {
        fullName: 'Nome',
        role: 'Ruolo',
        viewProject: 'Accesso operazione'
      }
    },
    internalNotes: {
      author: 'Nota di %{fullName}',
      creationDate: 'Pubblicata il ',
      newInternalNote: 'Nuova nota interna',
      title: 'Note interne'
    },
    internalReference: 'Riferimento interno',
    invite: {
      client: {
        defaultMessage: "%{userName} della società %{organisationName} la invita ad unirsi alla piattaforma OnceForAll nel quadro della sua partecipazione all'operazione %{projectName} al fine di facilitare la gestione dei suoi fornitori (Visura, DURC,…). Grazie alla soluzione OnceForAll, potrà accedere in modo completamente sicuro ai dossier unici, sempre completi e aggiornati dei suoi fornitori.\nNon appena si sarà iscritto, potrà accedere gratuitamente e in qualsiasi momento ai dossier amministrativi delle società che partecipano all'operazione %{projectName}."
      },
      depositor: {
        defaultMessage: "%{userName} di %{organisationName} la invita ad unirsi alla piattaforma OnceForAll nel quadro della sua partecipazione all' operazione %{projectName} al fine di semplificare e garantire la trasmissione regolare dei suoi certificati (Visura, DURC,...). \nGrazie alla soluzione OnceForAll, potrà creare online il suo dossier unico, sempre completo e aggiornato, disponibile per tutti i suoi clienti con pochi clic 7 giorni su 7, 24 ore su 24.\nNon appena sarà iscritto e collegato a %{organisationName}, potrà condividere il suo dossier online con tutti i suoi clienti per semplificare realmente e in modo duraturo i suoi scambi amministrativi."
      },
      title: "Invitare un'azienda"
    },
    myProjects: 'Operazioni',
    name: "Nome dell'operazione",
    noProjects: 'Nessuna operazione trovata',
    notifications: {
      cancel: "L'ho già fatto",
      grantAccess: "Avete dato accesso all'operazione ai vostri colleghi?",
      requiredDocuments: 'Avete definito i documenti richiesti per questa operazione?'
    },
    openingDate: 'DOC',
    organisationDocuments: "Documenti dell'impresa %{organisationName}",
    organisationHasNoDocuments: "L'impresa non ha alcun documento",
    organisations: {
      notice: "Potrà modificare queste informazioni dopo la creazione dell'operazione",
      title: 'Aziende'
    },
    ownerOrganisation: 'Proprietario',
    participants: {
      description: "partecipanti nell'operazione",
      title: 'Partecipanti'
    },
    projectAccepted: "L'invito all'operazione è stato accettato!",
    projectAlreadyClosed: 'Questa operazione è chiusa. Non può più unirsi ad essa.',
    projectAlreadyReplied: 'Ha già risposto a questo invito',
    projectClosedChip: 'Operazione chiusa',
    projectInviterRemoved: "Non può unirsi a questa operazione perché l'azienda che l'ha invitata non fa più parte dell'operazione.",
    projectRejected: "L'invito all'operazione è stato rifiutato!",
    provisionalAcceptanceDate: 'Data di fine prevista',
    quitus: 'Status del file',
    quitusDescription: 'dei partecipanti al progetto hanno una status del file valida',
    requiredDocuments: {
      message1: "__sRichiesto per questa operazione__s: I documenti selezionati in questa colonna saranno raccolti per tutte le aziende presenti sull'operazione secondo il loro settore di attività e il loro paese di appartenenza.",
      message2: "__sRichiesti per lo status del file relativa all'Operazione__s: questa colonna consente di personalizzare l'operazione quitus. La sua validità sarà calcolata dai documenti selezionati. Esempio: Operazione RIB verificata in Documenti da ritirare ma non in Richiesto per l'autorizzazione all'operazione: l'operazione RIB verrà richiesta all'azienda ma non invaliderà l'autorizzazione all'operazione se manca.",
      title: 'Documenti richiesti',
      tooltip: {
        FOREIGN: 'Questo documento è richiesto solo per le società e filiali estere',
        businessLines: 'Questo documento è richiesto unicamente per le aziende appartenenti ai seguenti settori di attività: ',
        businessLines_1: 'Questo documento è richiesto unicamente per le aziende appartenenti al seguente settore di attività: '
      }
    },
    roleForm: {
      change: 'Cambiare ruolo',
      choose: 'Scegliere questo ruolo',
      client: {
        firstPoint: "Vedere tutte le aziende partecipanti all'operazione",
        intro: "Creare un'operazione in qualità di __sCommittente__s permette di:",
        secondPoint: 'Invitare solo delle aziende principali',
        thirdPoint: "Accedere ai documenti di tutte le aziende dell'operazione"
      },
      generalContractor: {
        firstPoint: "Vedere le aziende partecipanti all'operazione",
        intro: "Creare un'operazione in qualità di __sAzienda principale__s permette di:",
        secondPoint: "Invitare le aziende all'operazione (Committente, aziende principali, subappaltatori)",
        thirdPoint: 'Accedere ai documenti dei suoi subappaltatori'
      },
      notice: 'La preghiamo di selezionare il ruolo di __s%{organisationName}__s in questa operazione',
      projectManagerClient: {
        firstPoint: "Vedere tutte le aziende partecipanti all'operazione",
        intro: "Creare un'operazione in qualità di __sDirettore dei lavori__s permette di:",
        secondPoint: "Invitare le aziende all'operazione (Committente, aziende principali, i suoi subappaltatori)",
        thirdPoint: "Accedere ai documenti di tutte le aziende dell'operazione"
      },
      title: "Ruolo nell'operazione"
    },
    search: {
      notfound: 'Questa operazione non esiste',
      placeholder: "Nome dell'operazione"
    },
    selectIntervention: {
      invitedBy: 'Invitato da %{invitingOrganisationName}',
      message: 'La tua impresa ha più ruoli in questo progetto, per favore seleziona il ruolo con cui vorresti visualizzare questo progetto.',
      title: 'Seleziona il ruolo'
    },
    showInvalidDocumentsPage: 'Vedere documenti non validi',
    subcontractors: {
      description: "subappaltatori nell'operazione",
      title: 'Subappaltatori'
    },
    tree: {
      title: 'Organigramma',
      clients: 'Proprietà del progetto',
      projectManagers: 'Gestione del progetto',
      supplyChain: 'Catena di subappalto'
    },
    type: {
      NOMINATIVE: 'Nominativa',
      STANDARD: 'Standard'
    },
    typeForm: {
      NOMINATIVE: {
        fifthPoint: "Avere una verifica documentale dedicata per l'operazione",
        firstPoint: "Mettere a disposizione uno spazio dedicato all'operazione",
        fourthPoint: 'Raccogliere dei documenti specifici',
        intro: "Creare un'operazione di tipo Nominativa permette di:",
        secondPoint: 'Gestire la catena di subappalto',
        thirdPoint: 'Controllare il cantiere grazie al pannello degli strumenti'
      },
      STANDARD: {
        firstPoint: "Mettere a disposizione uno spazio dedicato all'operazione",
        intro: "Creare un'operazione di tipo Standard permette di:",
        secondPoint: 'Gestire la catena di subappalto',
        thirdPoint: 'Controllare il cantiere grazie al pannello degli strumenti'
      },
      change: 'Cambiare tipo',
      choose: 'Scegliere questo tipo',
      notice: 'La preghiamo di selezionare il tipo di operazione che desidera creare',
      title: 'Tipo di operazione'
    },
    upgradeToNominative: {
      title: 'Convertire in operazione nominativa',
      tooltip: 'Non ci sono crediti operazione nominativa sufficienti'
    },
    viewDetails: 'Vedere i dettagli'
  },
  registerFirstTime: {
    import: 'Scaricare e convidire i vostri documenti',
    joinOrganisation: "Unirsi a un'impresa già esistente",
    joinOrganisationSubtitle: 'Utilizzate il codice fiscale della vostra impresa',
    network: 'Ampliate i vostri contatti',
    newOrganisation: 'Potete iscrivere una nuova impresa',
    newOrganisationSubtitle: 'Munitevi delle informazioni della vostra impresa prima di iniziare',
    optionsTitle: 'La vostra impresa non è ancora su OnceForAll',
    participate: 'Partecipare a delle operazioni',
    start: 'Cliccate sopra per iniziare !',
    startButton: 'Iscrivere la vostra impresa',
    subtitle: 'Avete/Potete',
    title: 'Prima connessione su OFA?',
    view: 'Consultare i documenti dei vostri fornitori'
  },
  rejectionReason: {
    displayLabel: 'Invito rifiutato: ',
    label: 'Selezioni un motivo di rifiuto',
    reason: {
      ACTRADIS_MEMBER: 'Già membro della piattaforma Actradis.',
      ALREADYACTIVECUSTOMER: 'Azienda in fase di iscrizione o già iscritta.',
      ALREADYMEMBEROFAFREEPLATFORM: 'Già membro di una piattaforma gratuita.',
      CESSATIONOFACTIVITY: 'Azienda in fase di cessazione di attività.',
      CESSATION_OF_ACTIVITY: 'Azienda in fase di cessazione di attività.',
      DOINVITATIONERROR: 'L’invito riguarda un cliente e non un fornitore.',
      DO_INVITATION_MISTAKE: 'L’invito riguarda un cliente e non un fornitore.',
      FILE_ALREADY_TRANSMITTED: 'Ha già trasmesso i suoi documenti.',
      FREE_PLATFORM_MEMBER: 'Già membro di una piattaforma gratuita.',
      INCORRECTCONTACTDETAILS: 'Le coordinate trasmesse sono errate.',
      INSCRIPTION_ONGOING: 'Azienda in fase di iscrizione o già iscritta.',
      INSUFFICIENT_CUSTOMERS_NUMBER: 'Collabora con pochissime aziende.',
      KEEP_SENDING_FILE_BY_EMAIL: 'Desidera scambiare i suoi documenti tramite e-mail o posta.',
      NOBUDGET: 'Non desidero pagare un abbonamento.',
      NOLONGERRESPONDING: 'Non è stato possibile raggiungerlo nonostante diversi tentativi.',
      NOT_INFORMED: 'Sembra non essere stato informato della procedura.',
      NOT_MANDATORY: 'La procedura non ha valore contrattuale.',
      NOT_WORKING_WITH_ORGANISATION: 'Non lavoro con questa azienda',
      NO_ACTIVE_CONTRACT: 'Non ho contratti attivi con questo cliente',
      NO_FILE_SHARING_WANTED: 'Non pensa di condividere il suo dossier con altri clienti',
      NO_LONGER_WORKING_WITH_ORGANISATION: 'Non lavoro più con questa azienda',
      NO_REASON_GIVEN: 'Non ha voluto comunicare i motivi della sua decisione.',
      PLATFORM_SECURITY_SCEPTIC: 'Dubita della sicurezza della piattaforma.',
      PRICE: 'Non desidero pagare un abbonamento.',
      PRICETOOHIGH: 'Non desidero pagare un abbonamento.',
      SUBJECT_STUDIED_BY_MANAGEMENT: 'L’argomento è all’esame a livello della sede o della direzione.',
      UNDERREVIEW: 'L’argomento è all’esame a livello della sede o della direzione.',
      UNKNOWN_CLIENT: 'Non conosco questo cliente',
      UNKNOWN_ORGANISATION: 'Non conosco questa azienda',
      UNREACHABLE: 'Non è stato possibile raggiungerlo nonostante diversi tentativi.',
      WORKS_WITH_ANOTHER_ORGANISATION: "Questo cliente lavora per un'altra organizzazione",
      WRONG_CONTACT_INFORMATIONS: 'Le coordinate trasmesse sono errate.'
    },
    title: 'Invito di %{invitingOrganisationName}'
  },
  relationship: {
    errorDepositorService: 'Deve cambiare offerta per gestire gli inviti inviati dai suoi clienti.'
  },
  resendInvitationReason: {
    explanatory: "La preghiamo di indicare perché desidera sollecitare l'invito",
    placeholder: "Sollecito l'invito perché ...",
    reason: 'Motivo',
    title: 'Invitare di nuovo'
  },
  settings: {
    collectorNotifications: 'Rapporti settimanali',
    collectorNotificationsMention: 'Abbonandosi, riceverà i rapporti settimanali via e-mail.\nUn rapporto settimanale raggruppa lo stato delle dichiarazioni liberatorie di tutti i suoi fornitori.',
    invitation: {
      priorAcceptation: {
        label: 'Accetto di condividere i miei documenti con i miei clienti senza previa accettazione da parte mia',
        notDepositor: 'Non può modificare questo parametro se non deposita documenti su OnceForAll',
        notManager: 'Non dispone di diritti sufficienti per modificare questo parametro'
      },
      title: 'Privacy'
    },
    mySettings: 'Parametri',
    subscribeTo: {
      COLLECTOR_EVENT: 'Si abboni alla notifica su evento',
      COLLECTOR_EVENT_PROJECT: 'Si abboni alla notifica su evento per operazione',
      COLLECTOR_PERIODIC: 'Si abboni al rapporto settimanale',
      COLLECTOR_PERIODIC_PROJECT: 'Si abboni al rapporto settimanale per operazione'
    },
    tooltip: {
      COLLECTOR_PERIODIC: 'Non ha fornitori!',
      COLLECTOR_PERIODIC_PROJECT: 'Non ha operazioni!'
    }
  },
  signature: {
    canceledMessage: 'La firma del documento è stata rifiutata con successo.',
    successMessage: 'Il documento è stato firmato con successo.'
  },
  subcontractor: {
    accessCode: {
      download: 'Scaricare il codice di accesso',
      label: 'Inserire un codice di accesso',
      modal: {
        errorNotFound: 'Questo codice di accesso non esiste o è già stato utilizzato.',
        message: 'La preghiamo di indicare il suo codice di accesso al fine di avere accesso al dossier del fornitore.',
        title: 'Inserire un codice di accesso'
      },
      success: 'Il fornitore è stato aggiunto al suo elenco!'
    },
    add: {
      addSuccess: "L'azienda %{name} è stato aggiunto al suo elenco di fornitori!",
      button: 'Aggiungere un fornitore',
      inviteSuccess: 'Invito inviato. In attesa di accettazione da parte del subappaltatore %{name}',
      title: 'Aggiungere un fornitore'
    },
    archives: 'Archivi',
    documents: 'Documenti',
    export: 'Esportare il dossier dei miei fornitori',
    invitations: {
      sent: 'Inviti inviati'
    },
    invite: {
      defaultMessage: '%{userName} di %{organisationName} la invita ad unirsi alla piattaforma OnceForAll al fine di semplificare e garantire la trasmissione regolare dei suoi certificati (Visura, DURC,…).\nGrazie alla soluzione OnceForAll, potrà creare online il suo dossier unico, sempre completo e aggiornato, disponibile per tutti i suoi clienti con pochi clic 7 giorni su 7, 24 ore su 24.\nNon appena sarà iscritto e collegato a %{organisationName}, potrà condividere il suo dossier online con tutti i suoi clienti per semplificare realmente e in modo duraturo i suoi scambi amministrativi.',
      inviteSuccess: "Una volta che l'utente invitato si registra su OnceForAll e aggiunge la sua organizzazione, questa sarà automaticamente collegata alla vostra come uno dei suoi fornitori.",
      reinviteDefaultMessage: "%{userName} da %{organisationName} ti invita a unirti di nuovo alla piattaforma OnceForAll per facilitare la gestione dei tuoi documenti. \nAs qualità di loro subappaltatore, darai a %{userName} l'accesso ai tuoi documenti che si trovano sulla piattaforma OnceForAll. \nGiven che hai già utilizzato la nostra piattaforma prima di tutto quello che devi fare è cliccare sul pulsante in basso quindi selezionare il tuo nuovo abbonamento.",
      resendSuccess: '%{name} è stata invitata di nuovo!',
      title: 'Invitare un fornitore'
    },
    mySubcontractors: 'Fornitori',
    projects: 'Operazioni',
    reinvite: {
      action: 'Invita di nuovo',
      text: 'Affinché possa aggiornare i suoi documenti, invitalo ad unirsi nuovamente alla rete OnceForAll cliccando sul pulsante qui sopra.',
      title: 'Questo fornitore non è più attivo sulla piattaforma',
      tooltip: 'Invita questo fornitore a unirsi di nuovo a OnceForAll'
    },
    search: {
      notFound: 'Nessun fornitore trovato'
    }
  },
  subscription: {
    collector: "L'impresa che recupera i documenti",
    collector_and_depositor: "L'impresa che recupera i documenti e che deposita i documenti",
    help: {
      firstPart: 'Troverete su ',
      link: 'questa pagina',
      secondPart: ' dettagli sul calcolo del numero di clienti.'
    },
    nbClients: 'Condividete i vostri documenti con __s%{count}__s clienti.',
    noResult: 'Per conoscere i dettagli della vostra iscrizione contattare il menager del conto',
    remainingNominativeProjects: '__s%{count}__s crediti restanti per operazioni nominative',
    remainingStandardProjects: '__s%{count}__s crediti restanti per le operazioni standard',
    remainingUserAccounts: '__s%{count}__s utilizzatori che potete ancora iscrivere',
    title: 'Offerte in corso',
    validUntil: 'Offerte valido fino al __s%{date}__s'
  },
  subscriptions: {
    plans: {
      clientOrganisations: 'Per i mandanti',
      collectDocuments: 'RACCOLGO DEI DOCUMENTI',
      currency: {
        EUR: '€'
      },
      customerServiceMessage: 'Per maggiori informazioni, contatti il nostro servizio commerciale.',
      fee: '* %{price} di costi di iscrizione il primo anno',
      fee_0: 'Senza costi di iscrizione',
      free: 'Gratuito',
      offer: 'Offerta',
      option: 'Come opzione',
      or: ' ',
      pricePeriod: {
        month: '__c%{count}__c / mese Iva escl.',
        none: '__c%{count}__c Iva escl.',
        year: '__c%{count}__c / anno Iva escl.'
      },
      seeMore: 'Maggiori informazioni',
      services: {
        de_cie_registration_purchase_v1: "Acquisto del suo HR-Auszug 1 volta all'anno",
        de_document_auth_v1: 'Verifica e autenticazione dei suoi documenti',
        de_illimited_hotline_v1: 'Accesso illimitato al nostro servizio clienti',
        de_included_clients_v1: 'Diffusione dei suoi documenti a %{count} clienti al massimo',
        de_online_dossier_v1: '__sConformità__s : Gestione del suo dossier online. Deposito dei documenti, archiviazione (per 15 anni), avvisi preventivi, firma elettronica',
        de_unlimited_clients_v1: 'Diffusione illimitata dei suoi documenti ai suoi clienti',
        fr_document_auth_v1: 'Verifica e autenticazione dei suoi documenti',
        fr_illimited_hotline_v2: 'Accesso illimitato al nostro servizio clienti',
        fr_included_broadcasting_mandate_v1: '__sConnessione con le altre piattaforme del mercato:__s e-Attestations, MyProcurement, Provigis, AWS',
        fr_included_collection_mandate_v1: '__sMandato di raccolta:__s i nostri team raccolgono al suo posto i suoi certificati presso gli organismi interessati',
        fr_included_onceforall_platforms_v1: '__sSincronizzazione dei documenti con le piattaforme Once for All :__s Actradis, Déclarations Légales, Hiveo',
        fr_kbis_purchase_v1: "Acquisto della Kbis 4 volte l'anno",
        fr_limited_clients_v1: 'Diffusione dei suoi documenti a __s%{count} clienti al massimo__s',
        fr_online_dossier_v1: '__sConformità__s : Gestione del suo dossier online. Deposito dei documenti, archiviazione (per 15 anni), avvisi preventivi, firma elettronica',
        fr_unlimited_clients_v1: 'Diffusione illimitata dei suoi documenti ai suoi clienti',
        fr_free_bdr: '__sBâtisseur de Relations__s : Accesso a nuove opportunità commerciali pubbliche e private, referenze e visibilità sulla nostra rete',
        it_document_auth_v1: 'Verifica e autenticazione dei suoi documenti',
        it_illimited_hotline_v1: 'Accesso illimitato al nostro servizio clienti',
        it_online_dossier_v1: '__sConformità__s : Gestione del suo dossier online. Deposito dei documenti, archiviazione (per 15 anni), avvisi preventivi, firma elettronica',
        it_unlimited_clients_v1: 'Diffusione illimitata dei suoi documenti ai suoi clienti'
      },
      shareDocuments: 'DEPOSITO DEI DOCUMENTI',
      smallOrganisations: 'Per le aziende di %{count} dipendenti al massimo',
      subscribe: 'Sottoscrivere',
      title: {
        de_basic_1y_v1: 'Basilare',
        de_oncefor2_1y_v1: 'OnceFor2',
        de_onceforall_1y_v1: 'OnceForAll',
        fr_collector_sme_1y_v1: 'Collectant PME',
        fr_essential_v1: 'ESSENTIEL',
        fr_experience_v1: 'EXPÉRIENCE',
        fr_horizon_v1: 'HORIZON',
        fr_liberty_v1: 'LIBERTÉ',
        fr_essentialbdr: 'BUSINESS ESSENTIEL',
        fr_experiencebdr: 'BUSINESS EXPÉRIENCE',
        fr_horizonbdr: 'BUSINESS HORIZON',
        fr_libertybdr: 'BUSINESS LIBERTÉ',
        fr_onceforeignbdr: 'BUSINESS ONCE FOREIGN',
        fr_oncefor2_1y: 'ONCEFOR2',
        fr_onceforall_1y: 'ONCEFORALL',
        fr_onceforeign_1y: 'Once Foreign',
        fr_onceforever_1y: 'ONCEFOREVER',
        fr_onceformore_1y: 'ONCEFORMORE',
        it_basiccollector_V1: 'Basic',
        it_onceforall_1y: 'OnceForAll',
        it_onceforeign_1y: 'OnceForeign'
      },
      unit: {
        project: ' / operazione',
        user: ' / utente'
      }
    },
    questions: {
      shareCompliance: {
        title: 'Desiderate condividere i vostri requisiti di conformità?',
        response: {
          yes: 'Yes',
          no: 'No'
        }
      },
      nbOfClients: {
        title: 'Quanti clienti?',
        response: {
          info: 'Selezionare il numero di clienti',
          twoClients: 'Fino a 2 clienti',
          twentyClients: 'Fino a 20 clienti',
          fiftyClients: 'Fino a 50 clienti',
          moreThanFiftyClients: '51 clienti e oltre'
        }
      }
    },
    title: 'Le offerte adatte alla sua azienda'
  },
  textsToValidate: {
    accept: {
      privacyPolicy_1: "Ho letto e accetto l'",
      privacyPolicy_2: 'Informativa sulla privacy',
      required: '.*',
      termsAndConditions_1: 'Ho letto e accetto le ',
      termsAndConditions_2: 'Condizioni Generali di Vendita ',
      termsAndConditions_3: 'e le ',
      termsAndConditions_4: 'Condizioni Generali di Utilizzo'
    },
    button: 'Accettare',
    privacyPolicy: 'Informativa sulla privacy',
    subtext: 'La invitiamo a leggere questi documenti e a confermarli prima di utilizzare i nostri servizi. Restiamo a sua disposizione per ogni precisazione.',
    termsAndConditions: 'Condizioni generali di vendita',
    termsOfUse: 'Condizioni generali di utilizzo',
    text: "L'evoluzione principale sta nella loro semplificazione e nella separazione in due testi distinti al fine di facilitarne la lettura e la comprensione:",
    title: 'La sua piattaforma si evolve, e anche le Condizioni generali che la accompagnano.',
    tooltip: 'Faccia clic per aprire il testo in una nuova scheda'
  },
  uploadImage: {
    errorTypeMessage: 'Il formato della sua immagine non è corretto.'
  },
  uploadLogo: {
    dragDropHere: 'Faccia scorrere e depositi qui il suo logo (png, jpg, jpeg)',
    title: "Logo dell'azienda",
    uploadSuccess: 'Il suo logo è stato aggiornato con successo'
  },
  user: {
    account: 'Informazioni personali',
    actions: {
      untieUser: 'Cancellare il suo accesso'
    },
    add: 'Aggiungere un utente',
    canNotUpdateProfile: 'Per modificare il suo profilo, la preghiamo di ',
    canNotUpdateProfileLinkText: 'contattare il servizio clienti.',
    changeEmailAddress: 'Cambiare il suo indirizzo e-mail',
    changeEmailButton: "Cambiare l'indirizzo e-mail",
    deactivatedUser: "L'utente %{firstname} %{lastname} è stato disattivato",
    domainNameAutomaticTieUser: 'Gli utenti che hanno come indirizzo e-mail __s%{domainName}__s possono accedere automaticamente a questa azienda con il ruolo __sEsploratore__s.',
    email: 'E-mail',
    emailChanged: "Una e-mail di conferma le è stata inviata all'indirizzo %{newEmail}",
    emailConfirmation: "Confermare l'e-mail",
    firstName: 'Nome',
    formTitle: 'Si iscriva su OnceForAll',
    invite: {
      alreadyInvited: 'Questo utente è già invitato',
      alreadyPartOfOrganisation: 'Questo utente ha già accesso alla sua azienda.',
      alreadySelected: 'Questo utente è già selezionato',
      defaultMessage: 'È stato invitato da %{userName} ad unirsi a %{organisationName} sulla piattaforma OnceForAll attraverso il seguente link:',
      self: 'Non aggiunga se stesso!',
      successMessage: 'Ha invitato %{count} utenti ad unirsi alla sua azienda',
      successMessage_1: 'Ha invitato %{name} ad unirsi alla sua azienda',
      title: 'Invitare un utente nella sua azienda'
    },
    language: 'Lingua',
    lastName: 'Cognome',
    manageProject: 'Gestione delle operazioni',
    maxUsersReached: 'Numero massimo di utenti raggiunto!',
    missingSubscription: "Questa azione è impossibile perché l'impresa non è collegata ad alcuna sottoscrizione.",
    mobilePhoneNumber: 'Numero di cellulare',
    myProfile: 'Dati',
    notSelectedWarning: 'Deve invitare un utente per confermare.',
    options: {
      COLLECTOR_PERIODIC_PROJECT_REPORT: 'Accetto di ricevere per posta il rapporto sullo stato dei documenti raccolti per operazione',
      SUGGESTION_DISPLAY: 'Acceto che dei clienti potenziali con i quali condividere il mio folder mi siano suggeriti',
      title: 'Opzioni'
    },
    password: 'Password',
    passwordConfirmation: 'Confermare la password',
    phoneNumber: 'Numero di telefono',
    position: 'Postazione',
    registrationDate: 'Data di iscrizione',
    role: 'Ruolo',
    roles: {
      CONSULTANT: 'Chi consulta',
      EXPLORER: 'Ruolo base',
      INVITING: 'Chi invita',
      MANAGER: "Amministratore dell' account"
    },
    securePasswordPolicy: {
      atLeast1Digit: 'Almeno 1 cifra',
      atLeast1Lowercase: 'Almeno 1 minuscola',
      atLeast1Uppercase: 'Almeno 1 maiuscola',
      atLeast8Characters: 'Almeno 8 caratteri',
      tooltip: 'Utilizzi almeno 8 caratteri con almeno 1 minuscola, 1 maiuscola e 1 cifra'
    },
    sign: 'Firma elettronica',
    title: 'Aggiungere un utente alla sua azienda',
    updateButton: 'Confermare'
  },
  vitrine: {
    access: {
      confirm: 'Crea la mia Lista Referenze',
      text1: '__sDigitalizzazione della lista referenze per la costruzione__s',
      text2: 'Scopri come creare e caricare la lista referenze per la costruzione dalla piattaforma OnceForAll.',
      text3: 'Tramite la nostra interfaccia online, puoi inserire tutte le informazioni relative alle tue Referenze, aggiungere foto ed esportare la Lista nel formato più appropriato.',
      text4: '__sRisparmia tempo rispondendo ai bandi di gara grazie a questa funzione, che ti consente di raccogliere le vostre Referenze su un\'unica piattaforma e di promuovere il vostro know-how e i vostri successi.__s',
      text5: 'Per saperne di più, clicca qui.',
      text6: 'Cliccando su "Crea la mia Lista Referenze", il tuo account utente e le tue aziende sulla piattaforma OnceForAll saranno sincronizzati automaticamente.'
    },
    discover: {
      cancel: 'Non voglio creare la mia Lista Referenze',
      cta: 'PROVA ORA',
      text1: '__sNOVITÀ: Crea e scarica la tua Lista Referenze in pochi click__s',
      text2: 'Raccogli le tue Referenze - Promuovi il tuo know-how e i tuoi successi - Risparmia tempo'
    }
  }
};
